import React from "react";
import { Link } from "react-router-dom";
import { HeartHandshake, ArrowRight } from "lucide-react";

export const SafeHavenBannerCard = () => (
  <div data-testid="home-safe-haven-slot">
    <p className="text-[11px] font-black uppercase tracking-[0.3em] text-fuchsia-400 mb-3 flex items-center gap-2">
      <HeartHandshake className="w-3.5 h-3.5" /> Get Help Now · Free & Confidential
    </p>
    <Link
      to="/safe-haven"
      className="group flex items-stretch gap-0 rounded-xl overflow-hidden border-2 border-fuchsia-500/70 hover:border-fuchsia-400 bg-gradient-to-r from-fuchsia-950/70 to-white/5 backdrop-blur transition-all hover:-translate-y-0.5 hover:shadow-xl h-[calc(100%-2rem)]"
      data-testid="home-safe-haven-card"
    >
      <div className="w-28 sm:w-32 flex-shrink-0 bg-gradient-to-b from-fuchsia-700 to-purple-950 flex flex-col items-center justify-center gap-2 p-3">
        <HeartHandshake className="w-10 h-10 text-white animate-pulse" />
        <span className="text-white text-[10px] font-black text-center leading-tight uppercase tracking-widest">Safe Haven</span>
      </div>
      <div className="p-4 flex flex-col justify-center min-w-0">
        <span className="text-[10px] font-black tracking-widest uppercase text-fuchsia-300">No More Suffering in Silence</span>
        <h3 className="text-white font-black text-base sm:text-lg leading-tight mt-1">Help for Abused Women, Men &amp; Children</h3>
        <p className="text-white/70 text-xs sm:text-sm mt-0.5">
          24/7 hotlines &amp; Memphis shelters — free, confidential, with a quick-exit button. En español también.
        </p>
        <span className="inline-flex items-center gap-1.5 text-xs font-bold mt-2 text-fuchsia-300 group-hover:underline underline-offset-4">
          Get help now <ArrowRight className="w-3.5 h-3.5" />
        </span>
      </div>
    </Link>
  </div>
);


export const SafeHavenCard = ({ lang = "en", dark = false, className = "", testId = "safe-haven-card" }) => {
  const es = lang === "es";
  return (
    <div
      className={`rounded-xl border-2 p-4 ${dark ? "border-fuchsia-400/50 bg-fuchsia-500/10" : "border-fuchsia-300 bg-fuchsia-50/80"} ${className}`}
      data-testid={testId}
    >
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${dark ? "bg-fuchsia-500/25" : "bg-fuchsia-100"}`}>
          <HeartHandshake className={`w-5 h-5 ${dark ? "text-fuchsia-300" : "text-fuchsia-700"}`} />
        </div>
        <div>
          <p className={`font-bold text-sm ${dark ? "text-white" : "text-slate-800"}`}>
            {es ? "¿Sufres abuso? No más sufrimiento en silencio" : "Facing abuse? No more suffering in silence"}
          </p>
          <p className={`text-sm mt-1 leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>
            {es
              ? "Refugio Seguro reúne líneas de ayuda 24/7 y refugios de Memphis para mujeres, hombres y niños — gratis, confidencial, con botón de salida rápida."
              : "Safe Haven gathers 24/7 hotlines and Memphis shelters for abused women, men & children — free, confidential, with a quick-exit button."}
          </p>
          <Link
            to="/safe-haven"
            className={`inline-block mt-2 text-sm font-semibold underline underline-offset-2 ${dark ? "text-fuchsia-300 hover:text-fuchsia-200" : "text-fuchsia-700 hover:text-fuchsia-900"}`}
            data-testid={`${testId}-link`}
          >
            {es ? "Obtén ayuda ahora →" : "Get help now →"}
          </Link>
        </div>
      </div>
    </div>
  );
};
